<script setup>
const props = defineProps({
  match: {
    type: Number,
    required: true,
  },
  vacancy: {
    type: Object,
    required: true,
  },
})

const user = useStrapiUser()

const isProfessional = computed(() => user.value?.type === 'professional')
const matchPersonality = computed(
  () => props.vacancy?.matchingscore_personality,
)
const matchCulture = computed(() => props.vacancy?.matchingscore_culture)
const matchCognitive = computed(() => props.vacancy?.matchingscore_cognitive)
const matchMotivations = computed(
  () => props.vacancy?.matchingscore_motivations,
)
</script>
<template>
  <div class="">
    <div class="mb-6 flex items-center justify-center">
      <div class="relative h-[118px] w-[118px]">
        <div
          class="absolute left-[50%] top-[50%] h-[116px] w-[116px] translate-x-[-50%] translate-y-[-50%] rounded-[50%] bg-secondary"
        ></div>
        <ClientOnly>
          <component
            :is="resolveComponent('VeProgress')"
            class="absolute left-0 top-0 h-[118px] w-[118px]"
            :progress="Math.round(match)"
            :legend-formatter="({ currentValue }) => `${currentValue || '-'}%`"
            color="#9EFF28"
            empty-color="#E7EDF3"
            :size="118"
            :thickness="7"
            :empty-thickness="7"
            animation="bounce 1500 500"
            font-size="1.5rem"
            font-color="#FFFFFF"
            dot="0"
          />
        </ClientOnly>
      </div>
    </div>

    <!-- TODO: dynamic assesment match from strapi -->
    <div class="grid grid-cols-2 gap-2 lg:mb-6">
      <VacanciesDetailMatchAssesment
        v-if="matchPersonality"
        :match="matchPersonality"
        title="Persoonlijkheid"
      />
      <VacanciesDetailMatchAssesment
        v-if="matchCulture"
        :match="matchCulture"
        title="Cultuur"
      />
      <VacanciesDetailMatchAssesment
        v-if="matchMotivations"
        :match="matchMotivations"
        title="Drijfveren"
      />
      <VacanciesDetailMatchAssesment
        v-if="matchCognitive"
        :match="matchCognitive"
        title="Cognitief"
      />
    </div>

    <div
      class="fixed bottom-0 left-0 z-30 flex w-full bg-white p-4 lg:static lg:p-0"
    >
      <ButtonInterest
        v-if="isProfessional && vacancy?.id"
        target-type="vacancy"
        :target-id="vacancy?.id"
        class="w-full"
        text="Toon anoniem interesse in vacature"
      />
    </div>
  </div>
</template>
<style>
.ep-legend--value {
  @apply font-black text-gray-900;
}
.tippy-tooltip {
  @apply bg-gray-900 p-3 text-xs;
}

.tippy-tooltip .tippy-arrow {
  @apply border-t-gray-900;
}
</style>
